import { useMemo } from "react";
import { useWidgetData } from "../dashboard/widgets/WidgetDataContext";
import { computePfmKpis } from "./pfmPeriod";

export function usePfmKpis() {
  const { filteredAccounts, charges, dateRange } = useWidgetData();
  const from = dateRange.from ?? null;
  const to = dateRange.to ?? null;

  return useMemo(
    () => computePfmKpis(filteredAccounts as any[], (charges ?? []) as any[], from, to),
    [filteredAccounts, charges, from, to],
  );
}
